import React, { useState, createContext, useContext } from 'react';
export interface Contract {
  id: string;
  zone: string;
  size: number;
  unitPrice: number;
  done: number;
  fileName?: string;
}
interface ContractsContextValue {
  contracts: Contract[];
  addContract: (contract: Omit<Contract, 'id'>) => void;
}
const ContractsContext = createContext<ContractsContextValue | undefined>(undefined);
// Seed with the contracts previously hard-coded in CmPropostePage
const INITIAL_CONTRACTS: Contract[] = [{
  id: 'c1',
  zone: 'Isola',
  size: 30,
  unitPrice: 36,
  done: 11
}, {
  id: 'c2',
  zone: 'Centro',
  size: 10,
  unitPrice: 42,
  done: 4
}];
export function ContractsProvider({
  children
}: {
  children: ReactNode;
}) {
  const [contracts, setContracts] = useState<Contract[]>(INITIAL_CONTRACTS);
  const addContract = (contract: Omit<Contract, 'id'>) => {
    setContracts(prev => [{
      ...contract,
      id: `c-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`
    }, ...prev]);
  };
  return <ContractsContext.Provider value={{
    contracts,
    addContract
  }} data-id="element-1182">
      {children}
    </ContractsContext.Provider>;
}
export function useContracts(): ContractsContextValue {
  const ctx = useContext(ContractsContext);
  if (!ctx) {
    throw new Error('useContracts must be used within a ContractsProvider');
  }
  return ctx;
}